module.exports = __webpack_public_path__ + "static/media/favicon.aced1c87.ico";